import { render, staticRenderFns } from "./MeasurementCalculations.vue?vue&type=template&id=b2539504&"
import script from "./MeasurementCalculations.vue?vue&type=script&lang=js&"
export * from "./MeasurementCalculations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports